import { Expose, Type } from 'class-transformer';
import { IsOptional, IsUUID } from 'class-validator';
import { SopResponseDto } from '../../sop/sop.response.dto';

export class SopRelationshipDto {
    @IsUUID()
    sopId: string;

    @IsOptional()
    @IsUUID()
    relationshipId?: string;
}

export class SopWithRelationshipResponseDto {
    @Expose()
    @Type(() => SopResponseDto)
    sop: SopResponseDto;

    @Expose()
    relationshipId?: string;
} 